/*
 * レイアウト内何処でも使えるJSコンポーネント
 */

// メインメニュー
require('./components/main_menu');
